import Api from './baseApi';

export default {
    createShipment: (payload) => Api.post('/api/YurticiKargo/CreateShipment', payload),
    cancelShipment: (payload) => Api.post('/api/YurticiKargo/CancelShipment', payload),
    queryShipment: (payload) => Api.post('/api/YurticiKargo/QueryShipment', payload),
    saveReturnShipmentCode: (payload) => Api.post('/api/YurticiKargo/SaveReturnShipmentCode', payload),
    trackingUrl: (payload) => Api.post('/api/YurticiKargo/TrackingUrl', payload),
    prefillFromOrder: (orderId) => Api.get(`/api/YurticiKargo/PrefillFromOrder/${orderId}`),
    sendOrderByBarcode: (payload) => Api.post('/api/YurticiKargo/SendOrderByBarcode', payload),
    sentList: (params) => Api.get('/api/YurticiKargo/SentList', { params }),
    statusByOrderId: (orderId) => Api.get(`/api/YurticiKargo/StatusByOrderId/${orderId}`),
    syncStatus: (orderId, payload) => Api.post(`/api/YurticiKargo/SyncStatus/${orderId}`, payload || {}),
    runSyncNow: (batchLimit) => Api.post(`/api/YurticiKargo/RunSyncNow${batchLimit ? '?batchLimit=' + batchLimit : ''}`),
    cancelOrderById: (orderId, payload) => Api.post(`/api/YurticiKargo/CancelOrderById/${orderId}`, payload),
    reshipOrder: (orderId, payload) => Api.post(`/api/YurticiKargo/ReshipOrder/${orderId}`, payload),
    markAsReturned: (orderId, payload) => Api.post(`/api/YurticiKargo/MarkAsReturned/${orderId}`, payload),
    setLostStatus: (orderId, payload) => Api.post(`/api/YurticiKargo/SetLostStatus/${orderId}`, payload),
    overdueNotifications: (topN) => Api.get('/api/YurticiKargo/OverdueNotifications', { params: { topN: topN || 20 } }),
    overdueList: (params) => Api.get('/api/YurticiKargo/OverdueList', { params }),
    cargoCostSettlement: (params) => Api.get('/api/YurticiKargo/CargoCostSettlement', { params }),
    markCargoCostPaid: (orderIds) => Api.post('/api/YurticiKargo/MarkCargoCostPaid', { orderIds })
}
